/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getETFDetails} from '../api'

 export const useQueryGetETFDetails = createReactQueryHook('getETFDetails', getETFDetails)
